import { render, staticRenderFns } from "./listbox_group.vue?vue&type=template&id=5a4cab26"
import script from "./listbox_group.vue?vue&type=script&lang=js"
export * from "./listbox_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports